<template :class="[!this.shouldDisplayMenu ? '' : appOpen]">
  <div :class="[!this.shouldDisplayMenu ? '' : rootOpen]">
    <div class="contener home">
      <NavBar @iconClicked="iconClicked" :menus="menus" />
    </div>
    <!-- route outlet -->
    <div class="contener"><router-view></router-view></div>
  </div>
  <div class="home">
    <FooterBar :menus="menus" />
  </div>
</template>

<script>
import NavBar from "./components/NavBar/NavBar.vue";
import FooterBar from "./components/FooterBar.vue";

export default {
  name: "App",
  components: {
    FooterBar,
    NavBar,
  },
  data() {
    return {
      isIconClicked: false,
      smallScreen: false,
      root: "root",
      rootOpen: "root root-open-menu",
      app: "app",
      appOpen: "app-open",
      menus: [
        {
          id: 0,
          title: "New Zealand plants",
          subMenus: [
            {
              id: 1,
              src: "tree.jpg",
              title: "Trees",
              link: "/category/tree",
              subtitle:
                "Trees are distinguished from other plants by their upright woody stem, roots and branches",
            },
            {
              id: 2,
              src: "fern.jpg",
              title: "Ferns",
              link: "/category/fern",
              subtitle:
                "Ferns are plants that reproduce via spores and have neither seeds nor flowers",
            },
            {
              id: 0,
              src: "coprosma_lemon01.jpg",
              title: "All plants",
              link: "/category/all",
              subtitle:
                "Trees are distinguished from other plants by their upright woody stem, roots and branches",
            },
          ],
        },
        {
          id: 1,
          title: "Recognize plants",
          subMenus: [
            {
              id: 1,
              src: "leaf.jpg",
              title: "Identify leaves",
              link: "/identify-leaf",
              subtitle: `There are basically four ways in which leaves can be arranged on a branch: in tufts, hand-shaped, alternating or opposite`,
            },
            {
              id: 2,
              src: "shrub.jpg",
              title: "Shrub or tree",
              link: "/shrub-tree",
              subtitle:
                "Generally speaking, if it has a distinct woody trunk, it is a tree. But really?",
            },
          ],
        },
      ],
    };
  },
  methods: {
    iconClicked: function (value) {
      this.isIconClicked = value;
    },
    handleResize() {
      this.smallScreen = window.matchMedia("(max-width: 768px)").matches
        ? true
        : false;
    },
  },
  computed: {
    shouldDisplayMenu() {
      if (this.isIconClicked && this.smallScreen) {
        document.body.classList.add("app-open");
      } else {
        document.body.classList.remove("app-open");
      }
      return this.isIconClicked && this.smallScreen;
    },
  },

  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style lang="scss">
.root-open-menu {
  height: 100vh;
  overflow: hidden;
}
.home {
  background-color: $color-gray;
  padding-top: $spacing-small;
  padding-right: $spacing-small;
  padding-left: $spacing-small;
}
.contener {
  padding-left: $spacing-small;
  padding-right: $spacing-small;
  padding-bottom: $spacing-small;
  @media screen and (min-width: $breakpoint-large) {
    padding-bottom: 16px;
  }
  @media screen and (min-width: $breakpoint-x-large) {
    padding-left: 10rem;
    padding-right: 10rem;
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $color-dark;
}
.app-open {
  position: absolute;
  height: 100vh;
  overflow: hidden;
  width: 100%;
}
</style>
